import { Injectable } from '@angular/core';
import { SocketEventWrapperService } from '../../socket-event-wrapper.service';
import {
    IWorkspaceAssetClientToServerEvents,
    IWorkspaceAssetServerToClientEvents,
} from '../../../../models/socket-events/workspace/asset/workspace-asset-event';

@Injectable()
export class WorkspaceAssetEventService {
    constructor(
        private socketEventWrapper: SocketEventWrapperService<
            IWorkspaceAssetClientToServerEvents,
            IWorkspaceAssetServerToClientEvents
        >
    ) {}

    onAssetUpdate() {
        return this.socketEventWrapper.fromEvent('onAssetUpdate');
    }
    onAssetCreated() {
        return this.socketEventWrapper.fromEvent('onAssetCreated');
    }
    onAssetDeleted() {
        return this.socketEventWrapper.fromEvent('onAssetDeleted');
    }

    onGeneratedVideo() {
        return this.socketEventWrapper.fromEvent('onVideoGenerated');
    }
}
